export const slideUp = {
    initial: {
        y: "100%"
    },
    open: (i) => ({
        y: "0%",
        transition: {
            duration: 0.6,       // Reduced from 1 second to 0.6 seconds
            delay: 0.01 * i      // Reduced multiplier delay to speed up the stagger effect
        }
    }),
    closed: {
        y: "100%",
        transition: { duration: 0.3 } // Reduced from 0.5 seconds to 0.3 seconds for a snappier close
    }
}

export const opacity = {
    initial: {
        opacity: 0
    },
    open: {
        opacity: 1,
        transition: { duration: 0.3 } // Faster fade in (down from 0.5 to 0.3 seconds)
    },
    closed: {
        opacity: 0,
        transition: { duration: 0.3 } // Faster fade out
    }
}
